import React, { useState } from "react";
import { Rating } from "@mui/material";

import { useDispatch } from "react-redux";
import { SetAnswersValue } from "../../../../../redux/slice/SurveySlice/AnswerSlice";
export default function Scores({ questionsindex, answers, AnswersFontScales }) {
  const dispatch = useDispatch();
  const [raitingvalue, setraitingvalue] = useState(0);

  function onChangeAnswer(value) {
    setraitingvalue(value);
    dispatch(SetAnswersValue({ index: questionsindex, value }));
  }
  return (
    <div className="w-full h-full flex items-center justify-center ">
      <div className="rating rating-lg m-10">
        <Rating
          sx={{ '& .MuiSvgIcon-root': { fontSize: AnswersFontScales } }}
          name="size-large"
          color="blue"
          disabled={answers !== undefined ? true : false}
          onChange={(e, newvalue) => onChangeAnswer(newvalue)}
          value={answers !== undefined ? answers : raitingvalue}
          size="large"
        />
      </div>
    </div>
  );
}
